import { Component, OnInit } from '@angular/core';
import { MenuItemsService } from '../../services/menu-items.service';
import { MenuItem } from '../../interfaces/menu-item';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { PagerService } from '../../services/pager-service';
import { CustomValidators } from '../../validator/custom-validators';
import { Observable } from 'rxjs/Observable';
import { mergeMap } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';
import 'rxjs/add/operator/map';
import { AppsyncService } from '../../services/appsync.service';
import * as Query from '../../global-query';
import update from 'immutability-helper';
import listMenu from '../../graphql/queries/listMenu';
import NewItemSubscription from '../../graphql/subscriptions/NewItemSubscription';
import UpdateItemSubscription from '../../graphql/subscriptions/UpdateItemSubscription';
import DeleteItemSubscription from '../../graphql/subscriptions/DeleteItemSubscription';
import { OrderService } from '../../services/order.service';
import { NgxSmartModalService } from 'ngx-smart-modal';

export class MenuData {
  constructor(public id: number = 0, public title: string = '', public price: number = null) {}
}

@Component({
  selector: 'app-item-create',
  templateUrl: './item-create.component.html',
  styleUrls: ['./item-create.component.scss']
})
export class ItemCreateComponent implements OnInit {
  public isError = false;

  public menuItems: MenuItem[];

  public selectedItem: MenuItem = { id: 0, title: '', price: 0 };

  itemForm: FormGroup;

  submitType = 'Save';

  // It maintains items form display status. By default it will be false.
  public showNew: Boolean = false;

  constructor(
    private menuService: MenuItemsService,
    private fb: FormBuilder,
    private pagerService: PagerService,
    private appsync: AppsyncService,
    private _orderService: OrderService,
    public ngxSmartModalService: NgxSmartModalService
  ) {
    this.createForm();
  }

  ngAfterViewInit() {

    this.ngxSmartModalService.setModalData('', 'popupOne');

  }

  ngOnInit() {
    this.appsync.client.hydrated().then((client) => {
      const observable = client.watchQuery({
        query: listMenu,
        fetchPolicy: 'cache-and-network'
      });

      observable.subscribe(({ data }) => {
        if (!data) {
          return console.log('ItemCreate listMenu - no data');
        }

        this.menuItems = data.listMenu;
      });

      observable.subscribeToMore({
        document: NewItemSubscription,
        updateQuery: (
          prev,
          {
            subscriptionData: {
              data: { onCreateItem: item }
            }
          }
        ) => {
          console.log('Subscription ItemCreate add', item, prev);
          if (!prev || !prev.listMenu) {
            return { listMenu: [] };
          }

          if (prev.listMenu.find((_item) => _item.id === item.id)) {
            return prev;
          }

          return update(prev, { listMenu: { $push: [item] } });
        }
      });

      observable.subscribeToMore({
        document: UpdateItemSubscription,
        updateQuery: (
          prev,
          {
            subscriptionData: {
              data: { onUpdateItem: item }
            }
          }
        ) => {
          console.log('Subscription ItemCreate update', prev, item);
          if (!prev || !prev.listMenu) {
            return { listMenu: [] };
          }
          // Find the updated item
          const updatedId = item.id;
          const index = prev.listMenu.findIndex((menu) => menu.id === updatedId);

          return update(prev, {
            listMenu: {
              [index]: {
                subset: {
                  $set: [item]
                }
              }
            }
          });
        }
      });

      observable.subscribeToMore({
        document: DeleteItemSubscription,
        updateQuery: (
          prev,
          {
            subscriptionData: {
              data: { onDeleteItem: item }
            }
          }
        ) => {
          console.log('Subscription ItemCreate delete', prev, item);

          if (!prev || !prev.listMenu) {
            return { listMenu: [] };
          }

          return update(prev, { listMenu: (arr) => arr.filter((_item) => _item.id != item.id) });
        }
      });
    });
  }

  /* get menuItems(): MenuItem[] {
         return this.menuService.menuItems;
     }*/

  createForm() {
    this.itemForm = this.fb.group({
      id: 0,
      title: ['', Validators.required],
      price: ['', [Validators.required, CustomValidators.validNumber]]
    });
  }

  onNew() {
    this.selectedItem = { id: 0, title: '', price: 0 };
    this.rebuildForm();
    this.ngxSmartModalService.getModal('popupOne').open();
  }

  onSubmit() {
    this.selectedItem = this.prepareSaveHero();
    // this.createItem(this.selectedItem);
    this.menuService.updateMenuItems(this.selectedItem).subscribe(
      (something) => {
        this.rebuildForm();
        this.showNew = false;
        this.ngxSmartModalService.close('popupOne');
      },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.isError = true;
      }
    );
  }

  prepareSaveHero(): MenuItem {
    const formModel = this.itemForm.value;

    const saveItem: MenuItem = {
      id: formModel.id,
      title: formModel.title,
      price: formModel.price
    };
    return saveItem;
  }

  createItem(menuItem) {
    this.appsync.client.hydrated().then((client) => {
      menuItem.id = uuid();
      client
        .mutate({
          mutation: Query.addMenu,
          variables: {
            id: menuItem.id,
            title: menuItem.title,
            price: menuItem.price,
            picture: '',
            halfAllowed: 1,
            tags: '',
            type: ''
          },
          optimisticResponse: () => ({ addMenuItem: { ...menuItem, __typename: 'MenuItem', version: 1 } }),
          update: (proxy, { data: { addMenuItem: _menuItem } }) => {
            console.log('addMenuItem update with:', _menuItem);
            const options = {
              query: listMenu
            };

            const data = proxy.readQuery(options);
            let hasBeenAdded = false;
            data.listMenu.map((item) => {
              if (item.id === _menuItem.id) {
                hasBeenAdded = true;
              }
            });
            if (hasBeenAdded) {
              return;
            }
            data.listMenu.push(_menuItem);
            proxy.writeQuery({ query: listMenu, data });

            // proxy.writeQuery({query: Query.listMenu, data: {listMenu: {..._menuItem}}});
          }
        })
        .catch((err) => console.log('Error registering user', err));
    });
  }

  rebuildForm() {
    this.itemForm.reset({
      id: this.selectedItem.id,
      title: this.selectedItem.title,
      price: this.selectedItem.price
    });
  }

  onEdit(id: number) {
    this.menuService.getMenuById(id).subscribe((res) => {
      this.selectedItem.id = res.id;
      this.selectedItem.title = res.title;
      this.selectedItem.price = res.price;
      this.rebuildForm();
      this.ngxSmartModalService.getModal('popupOne').open()
    });
  }

  onDelete(id: number) {
    this.menuService.deleteMenuItems(id).subscribe((res) => {
      /*const deletedMenuId = res.id;
                this._orderService.deleteOrdersByMenuId(deletedMenuId)
                    .subscribe(something => {

                    });*/
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/item-create/item-create.component.ts